import { motion } from "framer-motion";

const colVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            delay: i * 0.1,
            ease: [0.25, 0.46, 0.45, 0.94],
        },
    }),
};

function CareLineFooter() {
    const currentYear = new Date().getFullYear();

    return (
        <footer
            className="relative overflow-hidden pt-14 pb-8 font-[Plus_Jakarta_Sans,sans-serif]"
            style={{
                background:
                    "linear-gradient(180deg, #e0f5fb 0%, #e8f8fc 40%, #edf9fd 100%)",
            }}
        >
            <div
                className="absolute inset-0 opacity-[0.025] pointer-events-none z-0"
                style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
                    backgroundRepeat: "repeat",
                    backgroundSize: "128px 128px",
                }}
            />
            <div
                className="absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full pointer-events-none z-0"
                style={{
                    background:
                        "radial-gradient(circle, rgba(6,182,212,0.09) 0%, transparent 70%)",
                }}
            />
            <div
                className="absolute bottom-0 left-1/4 w-[300px] h-[300px] rounded-full pointer-events-none z-0"
                style={{
                    background:
                        "radial-gradient(circle, rgba(8,145,178,0.06) 0%, transparent 70%)",
                }}
            />
            <div
                className="absolute inset-0 pointer-events-none z-0 opacity-[0.055]"
                style={{
                    backgroundImage: `linear-gradient(rgba(6,182,212,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(6,182,212,0.6) 1px, transparent 1px)`,
                    backgroundSize: "60px 60px",
                }}
            />

            <div className="relative z-10 mx-auto max-w-[1280px] px-4 sm:px-6 md:px-10 lg:px-16 xl:px-[60px]">
                <div
                    className="mb-10 md:mb-12"
                    style={{ borderTop: "1px solid rgba(6,182,212,0.15)" }}
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 md:mb-12">
                    {/* Brand */}
                    <motion.div
                        className="sm:col-span-2 lg:col-span-1"
                        custom={0}
                        variants={colVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        <img
                            src="/careline-logo.svg"
                            alt="CareLine Logo"
                            className="h-8 mb-5"
                        />
                        <p
                            className="text-[13.5px] font-medium mb-6 leading-relaxed"
                            style={{ color: "rgba(71,105,130,0.7)" }}
                        >
                            Antrian klinik digital yang membantu mempermudah
                            pengelolaan antrian pasien agar pelayanan kesehatan
                            menjadi lebih tertib, cepat, dan nyaman.
                        </p>
                        <div className="flex gap-2.5 flex-wrap">
                            {[
                                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />,
                                <path d="M12 2.04c-5.5 0-10 4.49-10 10.02c0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89c1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z" />,
                                <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" />,
                                <path d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />,
                            ].map((iconPath, i) => (
                                <motion.a
                                    key={i}
                                    href="#"
                                    whileHover={{ y: -2 }}
                                    className="w-8 h-8 rounded-full flex items-center justify-center"
                                    style={{
                                        background: "rgba(255,255,255,0.8)",
                                        border: "1px solid rgba(6,182,212,0.18)",
                                        color: "rgba(6,182,212,0.75)",
                                        boxShadow:
                                            "0 1px 4px rgba(6,182,212,0.06)",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background =
                                            "rgba(6,182,212,0.08)";
                                        e.currentTarget.style.border =
                                            "1px solid rgba(6,182,212,0.30)";
                                        e.currentTarget.style.color = "#06B6D4";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background =
                                            "rgba(255,255,255,0.8)";
                                        e.currentTarget.style.border =
                                            "1px solid rgba(6,182,212,0.18)";
                                        e.currentTarget.style.color =
                                            "rgba(6,182,212,0.75)";
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        {iconPath}
                                    </svg>
                                </motion.a>
                            ))}
                        </div>
                    </motion.div>

                    <div className="hidden lg:block" />

                    {/* Services */}
                    <motion.div
                        custom={2}
                        variants={colVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        <h4
                            className="text-[14px] font-extrabold mb-5 tracking-[-0.01em]"
                            style={{ color: "#0f172a" }}
                        >
                            Layanan
                        </h4>
                        <ul className="space-y-3">
                            {[
                                "Sistem Antrian Online",
                                "Poliklinik & Dokter",
                                "Jadwal Praktik",
                                "Pendaftaran Pasien",
                            ].map((item) => (
                                <li key={item}>
                                    <a
                                        href="#"
                                        className="flex items-center gap-2 text-[13.5px] font-medium transition-colors"
                                        style={{
                                            color: "rgba(71,105,130,0.7)",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.color =
                                                "#0891B2";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.color =
                                                "rgba(71,105,130,0.7)";
                                        }}
                                    >
                                        <div
                                            className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                            style={{
                                                background: "#06B6D4",
                                                boxShadow:
                                                    "0 0 4px rgba(6,182,212,0.35)",
                                            }}
                                        />
                                        {item}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    {/* Contact */}
                    <motion.div
                        custom={3}
                        variants={colVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        <h4
                            className="text-[14px] font-extrabold mb-5 tracking-[-0.01em]"
                            style={{ color: "#0f172a" }}
                        >
                            Kontak Kami
                        </h4>
                        <ul className="space-y-4">
                            {[
                                {
                                    icon: (
                                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                    ),
                                    text: "Jl. Kesehatan No. 123, Malang",
                                },
                                {
                                    icon: (
                                        <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-2.2 2.2a15.11 15.11 0 0 1-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1.01A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z" />
                                    ),
                                    text: "(021) 1234 5678",
                                },
                                {
                                    icon: (
                                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                    ),
                                    text: "support@careline.id",
                                },
                            ].map(({ icon, text }, i) => (
                                <li
                                    key={i}
                                    className="flex items-start gap-3 text-[13.5px] font-medium"
                                    style={{ color: "rgba(71,105,130,0.7)" }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-4 h-4 mt-0.5 flex-shrink-0"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{
                                            color: "rgba(6,182,212,0.75)",
                                        }}
                                    >
                                        {icon}
                                    </svg>
                                    {text}
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </div>

                <motion.div
                    className="pt-7 text-center text-[13px] font-medium"
                    style={{
                        borderTop: "1px solid rgba(6,182,212,0.12)",
                        color: "rgba(71,105,130,0.5)",
                    }}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                >
                    &copy; {currentYear} CareLine by Qease. All rights reserved.
                </motion.div>
            </div>
        </footer>
    );
}

export default CareLineFooter;